<template>
  <v-stepper
    alt-labels
    v-model="currentStep"
    v-if="steps && steps.length > 0"
  >
    <v-stepper-header>
      <template v-for="(step, index) in steps">
        <v-stepper-step
          edit-icon="$complete"
          :complete="step.complete"
          :step="index+1"
          :key="index"
          :color="getColor(index+1, step.complete)"
        >
          {{ $t(`order.checkin.steps.${step && step.name.toLowerCase()}`) }}
        </v-stepper-step>
        <v-divider
          :key="`${index}-divider`"
          v-if="index+1 !== steps.length"
        />
      </template>
    </v-stepper-header>
  </v-stepper>
</template>

<script>
  import { mapState, mapActions } from 'vuex'

  export default {
    name: 'CheckinStepper',
    beforeMount() {
      this.$store.dispatch('layout/checkSteps')
        .then(response => {
          // console.log('executed layout/checkSteps', response)
        })
    },
    computed: {
      ...mapState('layout', {
        steps: 'completedCheckinSteps'
      }),
      ...mapState('layout', ['currentStep'])
    },
    methods: {
      ...mapActions('layout', ['goToStepper']),
      getColor(step, isComplete) {
        const isCurrent = step == this.currentStep
        if (isComplete && !isCurrent) {
          return 'success'
        } else if (isCurrent) {
          return 'primary'
        } else {
          return
        }
      },
    },
  }
</script>

<style lang="scss">
  $stepper-header-height: 80px;

  .checkin .v-stepper__step--inactive {
    opacity: 0.5;
  }

  @media only screen and (max-width: 959px) {
    .checkin {
      .v-stepper__step {
        flex-basis: 95px !important;
        padding: 15px;
        .v-stepper__step__step {
          margin-bottom: 8px;
        }
        .v-stepper__label {
          font-size: 12px;
        }
      }
      .v-divider {
        margin: 28px -27px 0 !important;
      }
    }

    .v-stepper:not(.v-stepper--vertical) .v-stepper__label {
      display: flex !important;
      font-size: 14px;
    }
  }
</style>
